import {Injectable} from '../../helpers';
import {CashDrawerTransaction, ReservationTransaction} from "../../pms-api/models";
import moment from "moment";

export class VoucherService extends Injectable {

    static get $inject() {
        return [
            'ReceiptVoucherPmsApiService',
            'PaymentVoucherPmsApiService',
        //  'CashDropVoucherPmsApiService',
            'DownloadFile',
            '$rootScope',
        ];
    }

    serviceByType(transactionType) {
        const services = {
            receipt: this.ReceiptVoucherPmsApiService,
            payment: this.PaymentVoucherPmsApiService,
            //cash_drop: this.CashDropVoucherPmsApiService,
        }

        return services[transactionType] || null;
    }

    /**
     * @public
     * @param {ReservationTransaction|HouseAccountTransaction|CashDrawerTransaction} transaction
     * @param {number} propertyId
     */
    viewVoucherPdfByTransaction(transaction, propertyId) {
        const type = this.getTransactionType(transaction);
        const service = this.serviceByType(type);
        if (!service) {
            console.warn(`Service for ${type} is not implemented or not assigned in VoucherService`)
            return Promise.reject();
        }

        const payload = this.getPdfPayload();

        return service.viewPdf(transaction.voucher_id, propertyId, payload).then(this.downloadFile.bind(this));
    }

    viewPdf(apiService, voucherId, propertyId) {
        const payload = this.getPdfPayload();

        return apiService.viewPdf(voucherId, propertyId, payload).then(this.downloadFile.bind(this));
    }

    exportExcel(apiService, property, loadParams = {}) {
        return apiService.exportExcel(loadParams, property).then(this.downloadFile.bind(this));
    }

    downloadFile(response) {
        const contentDispositionHeader = response.headers('Content-Disposition');
        const fileName = this.getFileName(contentDispositionHeader);

        return this.DownloadFile.downloadAsBlob(response.data, fileName);
    }

    /**
     *
     * @param {string} contentDispositionHeader
     * @returns {string}
     */
    getFileName(contentDispositionHeader) {
        const fileName = (contentDispositionHeader || '').split('filename=')[1];
        if (!fileName) {
            return 'Voucher_' + moment().format('YYYY-MM-DD_HH:mm:ss');
        }

        return fileName;
    }

    getTransactionType(transaction) {
        return transaction.voucher_type;
    }

    getPdfPayload() {
        return {
            web_language: this.$rootScope.$lang,
        };
    }
}



// WEBPACK FOOTER //
// ./src/app/services/voucher.service.js